import React, { useState } from "react";
import { ReactComponent as RaceSportIcon } from '../../assets/race-flag.svg';

import { getLabel } from "../../data/labels";
import { getUrlToFetch } from '../../data/utils/getUrlToFetch';
import { getAccountIds } from '../../data/utils/getAccountIds';
import { getConfiguration } from '../../data/utils/configuration';
import { useFetch } from "../../data/fetch/useFetch";
import { systemCode } from "../..";
import { concatUrlPathnames } from "../../data/sport-utils";

export default function RaceSportButtonScroller(props) {
    const conf = getConfiguration();
    const [isRaceActive,setIsRaceActive] = useState(false);
    const numConto = getAccountIds()?.split(";")?.[1] || '';
    let hrefLink = '/xcasinoracesport';

    try {
        if(typeof window.cg_SEO_URL_MAPPING_REVERSE != 'undefined') {
            hrefLink = concatUrlPathnames('/',JSON.parse(window.cg_SEO_URL_MAPPING_REVERSE)['xcasinoracesport']);
        }
    }catch(err) {
        console.error(err);
    }

    const [isLoading, isError, data] = useFetch(getUrlToFetch(conf.xrc?.url), {
        system_code: systemCode,
        num_conto: numConto,
        skipBaseParams: true
    }, (data) =>{
        try {
            if(parseInt(data?.raceAttiva) > 0 && !isRaceActive){
                setIsRaceActive(true);
            }
        }catch(err) {
            if(isRaceActive) {
                setIsRaceActive(false);
            }
            console.error(err);
        }
    },
    conf.xrc?.enabled? true: false
    );


    return (isRaceActive &&
        <>
            <a href={hrefLink} className="xsport-race-sport-icon-container relative h-sports-navbar-height min-w-sports-navbar-height mx-1 shrink-0 flex flex-col items-center justify-center">
                <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center">
                    <div className="xsport-race-sport-icon xs-sport-icon col-start-1 col-end-13 row-start-1 row-end-10 inline-block h-[24px] w-[24px]">
                    <RaceSportIcon />
                    </div>
                    <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{getLabel('race_sport.title', 'Race Sport')}</div>
                </div>
            </a>
        </>
    )
}